import React from 'react';

function SearchIcon({ width = 22, height = 22, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 22 22">
      <g>
        <path d="M15.1465199,15.4387972 L19.8573661,20.1511432 C20.0521558,20.345995 20.0513908,20.6611504 19.8556573,20.8550626 C19.6599239,21.0489748 19.3433423,21.0482132 19.1485526,20.8533615 L14.3855913,16.0888838 C12.8796351,17.2370525 10.9990043,17.9189144 8.95901639,17.9189144 C4.01069187,17.9189144 -1.2200405e-13,13.9069456 -1.20792265e-13,8.95945718 C-1.1958048e-13,4.01196879 4.01069187,-7.94020646e-16 8.95901639,4.17969311e-16 C13.9073409,1.62995927e-15 17.9180328,4.01196879 17.9180328,8.95945718 C17.9180328,11.5074423 16.8542732,13.8072986 15.1465199,15.4387972 Z M16.9180328,8.95945718 C16.9180328,4.56069143 13.3539713,0.995495242 8.95901639,0.995495242 C4.56406147,0.995495242 1,4.56069143 1,8.95945718 C1,13.3582229 4.56406147,16.9234191 8.95901639,16.9234191 C13.3539713,16.9234191 16.9180328,13.3582229 16.9180328,8.95945718 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default SearchIcon;
